import {viewport} from '../../src/js/functions';

jQuery(function ($) {
    function initialize($block) {
        $block.find('.slider').owlCarousel({
            items: 1,
            loop: true,
            dots: false,
            nav: true,
        });

        if(viewport().width >= 768) {
            $block.find('.slide img, .box').matchHeight({});
        }

        $(window).on('resize', function() {
            if(viewport().width >= 768) {
                $block.find('.slide img, .box').matchHeight({});
            } else {
                $block.find('.slide img, .box').matchHeight({remove: true});
            }
        });
    }

    $('.block--text-box-image-slider').each(function () {
        initialize($(this));
    });
});